var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vt-side-panel thin-scroll",class:_vm.classes},[_vm._t("default"),(_vm.loading)?_c('div',{staticClass:"spinner-wrapper"},[_c('vt-loading')],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }